import styled from 'styled-components';
import { Button, Row } from '@snsw-gel/react';
import { vars } from '@snsw-gel/theming';

export const StyledBackButton = styled(Button)`
  width: fit-content;
`;

export const StyledRow = styled(Row)`
  margin-top: 2.5rem;
`;

export const FormContainer = styled.div`
  max-width: 628px;
  div:has(textarea) {
    max-width: unset;
  }
`;

export const FieldWrapper = styled.div`
  max-width: ${vars.layouts.inputWidths['xl']};
  width: 100%;
`;

export const StyledHeadingWrapper = styled.div`
  && h1,
  && h2,
  && h3 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
`;
